export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

export const AUTHENTICATION = {
  GET_USER_INFO: `${BASE_URL}/account/getUser`,
  AUTH_LOGIN: `${BASE_URL}/api/login`,
  AUTH_LOGOUT: `${BASE_URL}/api/logout`,
  AUTH_REGISTER: `${BASE_URL}/register/save`,
  GET_USERS: `${BASE_URL}/account/getUsers`,
  PROCESS_RFID: `${BASE_URL}/account/processRFID`,
  DELETE_RFID: `${BASE_URL}/account/deleteRfid`,
  REGISTER_RFID: `${BASE_URL}/account/registerRfid`,
  GET_EMPLOYEES: `${BASE_URL}/account/getAllEmployees`,
  GET_ONLINE_EMPLOYEES: `${BASE_URL}/account/getOnlineEmployee`,
};

export const USER_MANAGEMENT = {
  FIND_USERS: `${BASE_URL}/team/fetchLinkedUsers`,
  UPDATE_USER: `${BASE_URL}/team/update`,
  DELETE_USER: `${BASE_URL}/team/delete`,
  GET_ROLES: `${BASE_URL}/team/getRoles`,
  GET_LOCATION_DETAIL: `${BASE_URL}/team/getLocationPeople`,
};
export const DASHBOARD = {
  POINT_REPORT_PDF: `${BASE_URL}/report/previewPointReport`,
  MATCH_POINT_REPORT_PDF: `${BASE_URL}/report/previewMatchPointReport`,
  MASTER_READING_REPORT_PDF: `${BASE_URL}/report/previewMasterReadingReport`,
};

export const ALERTS = {
  FETCH_ALERTS: `${BASE_URL}/alert/listAlerts`,
  SNOOZE_ALERT: `${BASE_URL}/alert/snoozeAlert`,
  RESOLVE_ALERT: `${BASE_URL}/alert/resolveAlert`,
  DELETE_ALL_ALERTS: `${BASE_URL}/alert/deleteAllAlerts`,
};

export const ACCOUNT = {
  GET_USER_SETTING: `${BASE_URL}/account/getUserSetting`,
  SAVE_USER_SETTING: `${BASE_URL}/account/saveUserSetting`,
};

export const CUSTOMER = {
  LIST_ALL_CUSTOMER: `${BASE_URL}/customer/list`,
  SAVE_CUSTOMER: `${BASE_URL}/customer/save`,
  DELETE_CUSTOMER: `${BASE_URL}/customer/delete`,
  ADD_FILES: `${BASE_URL}/customer/addFiles`,
  DELETE_FILES: `${BASE_URL}/customer/deleteFiles`,
  PREVIEW_FILE: `${BASE_URL}/customer/previewFile`,
  LIST_CUSTOMER_POINTS: `${BASE_URL}/customer/customerPointsList`,
  LIST_CUSTOMER_PENDING: `${BASE_URL}/customer/customerPendingList`,
  DELETE_CUSTOMER_PENDING: `${BASE_URL}/customer/deleteCustomerPending`,
  PREVIEW_IMAGE: `${BASE_URL}/customer/previewImage`,
  SET_CUSTOMER_TICKET: `${BASE_URL}/customer/setTicket`,
  SET_CUSTOMER_POINTS: `${BASE_URL}/customer/setPoints`,
  ENROLL_CUSTOMER: `${BASE_URL}/customer/enrollCustomer`,
  RAFFLE_CUSTOMERS: `${BASE_URL}/customer/searchByCustomerName`,
  LIST_ALL_RAFFLE: `${BASE_URL}/raffle/listRaffles`,
  SAVE_RAFFLE: `${BASE_URL}/raffle/saveRaffle`,
  UPLOAD_RAFFLE_PHOTO: `${BASE_URL}/raffle/uploadRafflePhoto`,
  DELETE_RAFFLE: `${BASE_URL}/raffle/deleteRaffle`,
  GET_POINT_WATCHING: `${BASE_URL}/customer/customerPendingByUserAndDate`,
  PREVIEW_POINT_WATCHING_IMAGE: `${BASE_URL}/customer/previewPointWatchingImage`,
  GET_POINT_HISTORY: `${BASE_URL}/customer/getCustomerHistory`,
  GET_RECENT_VISITS: `${BASE_URL}/customer/getHistory`,
  VALIDATE_CUSTOMER_NAME: `${BASE_URL}/customer/validateCustomer`,

  LIST_ALL_HISTORICAL_CUSTOMER: `${BASE_URL}/customer/listArchieveCustomer`,
  RESTORE_HISTORICAL_CUSTOMER: `${BASE_URL}/customer/restoreCustomer`,
};

export const TICKET_OUT = {
  LIST_ALL_TICKET_OUT: `${BASE_URL}/ticketOut/list`,
  SAVE_TICKET_OUT: `${BASE_URL}/ticketOut/save`,
  DELETE_TICKET_OUT: `${BASE_URL}/ticketOut/delete`,
};

export const TRANSACTION = {
  LIST_ALL_TRANSACTION: `${BASE_URL}/transaction/list`,
  SAVE_TRANSACTION: `${BASE_URL}/transaction/save`,
  DELETE_TRANSACTION: `${BASE_URL}/transaction/delete`,
  TRANSACTION_REPORT_PDF: `${BASE_URL}/transaction/previewReport`,
  CASH_LEFT: `${BASE_URL}/transaction/saveCashLeft`,
  ROLLOVER: `${BASE_URL}/transaction/rollover`,
  ROLLOVER_REQUEST: `${BASE_URL}/transaction/listPendingTransfers`,
  LIST_CATEGORY: `${BASE_URL}/transaction/listCategory`,
  EDIT_CATEGORY: `${BASE_URL}/transaction/editCategory`,
};

export const REPORT = {
  GLOBAL_PDF: `${BASE_URL}/report/`,
  LIST_REPORT: `${BASE_URL}/report/weeklyReport`,
  UPDATE_REPORT_FIELD: `${BASE_URL}/report/updateReportField`,
  UPDATE_MANAGER_BANK: `${BASE_URL}/report/updateManagerBank`,
  GET_MANAGER_SUMMARY: `${BASE_URL}/report/getManagerSummaryByLocation`,
  SAVE_MANAGER_SUMMARY: `${BASE_URL}/report/saveManagerSetting`,
  UPDATE_MANAGER_SUMMARY: `${BASE_URL}/report/updateManagerSummary`,
  SHORT_ANALYSIS: `${BASE_URL}/report/shortAnalysis`,
};

export const COMPANY = {
  LIST_COMPANIES: `${BASE_URL}/company/list`,
  LIST_AVAILABLE_COMPANIES: `${BASE_URL}/company/listAvailableCompanies`,
  CREATE_COMPANY: `${BASE_URL}/company/create`,
  UPDATE_COMPANY: `${BASE_URL}/company/update`,
  LIST_MASTER_ADMIN: `${BASE_URL}/company/getMasterAdmins`,

  GENERATE_LICENSE: `${BASE_URL}/company/createLicenseKey`,
  ACTIVATE_LICENSE: `${BASE_URL}/company/activateCompanyWithKey`,
  GET_LICENSE: `${BASE_URL}/company/viewCompanyLicenseKey`,
  RENEW_LICENSE: `${BASE_URL}/company/renewLicenseKey`,
  REVOKE_LICENSE: `${BASE_URL}/company/revokeLicenseKey`,
  LIST_ACTIVE_LICENSE: `${BASE_URL}/company/getLicenseHistory`,

  UPDATE_LICENSE_AMOUNT: `${BASE_URL}/company/updateLicenseAmount`,
  ACTUAL_PROJECTION: `${BASE_URL}/company/getActualMembership`,
  YEARLY_PROJECTION: `${BASE_URL}/company/getYearlyProjections`,
  GET_COMPANY_MEMBERSHIPS: `${BASE_URL}/company/getCompanyMemberships`,
  LIST_LICENSE_PAYMENTS: `${BASE_URL}/company/listLicensePayments`,
  UPDATE_LICENSE_PAYMENT: `${BASE_URL}/company/updateLicensePayment`,
  RECORD_NEXT_CYCLE_PAYMENT: `${BASE_URL}/company/recordNextCyclePayment`,
  MARK_CYCLE_PAID: `${BASE_URL}/company/markCyclePaid`,
  SET_AUTO_RENEWAL: `${BASE_URL}/company/setAutoRenewal`,
};

export const UUID = {
  GET_UUID: `${BASE_URL}/uuid/getUUID`,
  GET_UUIDS: `${BASE_URL}/uuid/getUUIDs`,
};

// Phase 2 — Stripe. PUBLIC_CONFIG / PAY_AND_ACTIVATE_FROM_KEY / PAY_NOW_STATUS
// are server-side permitAll (used by the locked-out Login Pay flow). The
// rest require ROLE_OWNER / ROLE_TECH_ADMIN / ROLE_MASTER_ADMIN.
export const STRIPE = {
  PUBLIC_CONFIG: `${BASE_URL}/stripe/publicConfig`,
  CREATE_SETUP_INTENT: `${BASE_URL}/stripe/createSetupIntent`,
  CREATE_PAY_NOW: `${BASE_URL}/stripe/createPayNow`,
  PAY_AND_ACTIVATE_FROM_KEY: `${BASE_URL}/stripe/payAndActivateFromKey`,
  PAY_NOW_STATUS: `${BASE_URL}/stripe/payNowStatus`,
  UPDATE_SAVE_PREFERENCE: `${BASE_URL}/stripe/updateSavePreference`,
  LIST_SAVED_CARDS: `${BASE_URL}/stripe/listSavedCards`,
  DETACH_PAYMENT_METHOD: `${BASE_URL}/stripe/detachPaymentMethod`,
  SET_DEFAULT_CARD: `${BASE_URL}/stripe/setDefaultCard`,
};

export const MACHINE = {
  LIST_MACHINE: `${BASE_URL}/machine/list`,
  EDIT_MACHINE: `${BASE_URL}/machine/edit`,
  LIST_ASSIGN_MACHINE: `${BASE_URL}/machine/listAssignTemplates`,
  EDIT_ASSIGN_MACHINE: `${BASE_URL}/machine/assignMachineToGame`,
  UPDATE_READING: `${BASE_URL}/machine/updateReading`,
  LIST_READING: `${BASE_URL}/machine/listReading`,
  LIST_MATCH_TICKETS: `${BASE_URL}/machine/matchTickets`,
  LIST_SESSION_ID: `${BASE_URL}/machine/getSessionIds`,
  ADD_MACHINE_PICTURE: `${BASE_URL}/machine/addMachinePicture`,
  LIST_MACHINE_PICTURE: `${BASE_URL}/machine/listMachinePicture`,
  DELETE_MACHINE_PICTURE: `${BASE_URL}/machine/deleteMachinePicture`,
  AVAILABLE_EMPLOYEE_SESSION: `${BASE_URL}/machine/getAvailableEmployeeSessions`,
  START_SESSION: `${BASE_URL}/machine/startNewSession`,
  END_SESSION: `${BASE_URL}/machine/endSession`,
  CANCEL_SESSION: `${BASE_URL}/machine/cancelSession`,
  LOAD_STARTED_SESSION: `${BASE_URL}/machine/loadStartedSession`,
  RESET_MACHINE: `${BASE_URL}/machine/resetMachine`,
  GET_PREV_IN_OUT: `${BASE_URL}/machine/getPreviousInAndOutReading`,
  OPEN_LAST_READING_SESSION: `${BASE_URL}/machine/openReadingSession`,
  GET_LAST_TWO_READING_SESSION: `${BASE_URL}/machine/getLastTwoReadingSessions`,
  LIST_DELETED_READING_SESSIONS: `${BASE_URL}/machine/listDeletedReadingSessions`,
  RESTORE_READING_SESSION: `${BASE_URL}/machine/restoreReadingSession`,
  DELETE_FOREVER_READING_SESSION: `${BASE_URL}/machine/deleteForeverReadingSession`,
};

export const CLOCK = {
  CLOCK_IN: `${BASE_URL}/clock/clockIn`,
  CLOCK_OUT: `${BASE_URL}/clock/clockOut`,
  FORCE_CLOCK_OUT: `${BASE_URL}/clock/forceClockOut`,
  LOAD_CLOCK_RECORD: `${BASE_URL}/clock/loadClockRecords`,
  LIST_EMPLOYEE_SESSION: `${BASE_URL}/clock/listEmployeeSession`,
  UPDATE_EMPLOYEE_STATUS: `${BASE_URL}/clock/updateStatus`,
  MANUAL_CLOCK_IN: `${BASE_URL}/clock/manualClockSave`,
  DELETE_EMPLOYEE_SESSION: `${BASE_URL}/clock/deleteEmployeeSession`,
};

export const GAME = {
  LIST_GAME: `${BASE_URL}/game/list`,
  EDIT_GAME: `${BASE_URL}/game/edit`,
};

export const NOTE = {
  LIST_NOTES: `${BASE_URL}/note/list`,
  ADD_NOTE: `${BASE_URL}/note/addNote`,
  DELETE_NOTE: `${BASE_URL}/note/deleteNote`,
};

export const RULES = {
  LIST_RULES: `${BASE_URL}/rule/list`,
  SAVE_RULES: `${BASE_URL}/rule/save`,
};

export const BONUS_API = {
  LIST_MANAGE_BONUS: `${BASE_URL}/bonus/list`,
  SAVE_MANAGE_BONUS: `${BASE_URL}/bonus/save`,
  DELETE_MANAGE_BONUS: `${BASE_URL}/bonus/delete`,
  PREVIEW_BONUS_IMAGE: `${BASE_URL}/bonus/previewImage`,
  SAVE_BONUS: `${BASE_URL}/bonus/saveBonus`,
  DELETE_BONUS: `${BASE_URL}/bonus/deleteBonus`,
  LIST_CLAIM_BONUS: `${BASE_URL}/bonus/bonusList`,
  UPLOAD_BONUS_PHOTO: `${BASE_URL}/bonus/uploadBonusPhoto`,
};

export const LOAN = {
  LIST_CUSTOMER_LOAN: `${BASE_URL}/loan/listCustomerLoan`,
  SAVE_CUSTOMER_LOAN: `${BASE_URL}/loan/saveCustomerLoan`,
  LIST_EMPLOYEE_LOAN: `${BASE_URL}/loan/listEmployeeLoan`,
  SAVE_EMPLOYEE_LOAN: `${BASE_URL}/loan/saveEmployeeLoan`,
  LIST_ZELLE_LOAN: `${BASE_URL}/loan/listZelleLoan`,
  SAVE_ZELLE_LOAN: `${BASE_URL}/loan/saveZelleLoan`,
};

export const AUDIT = {
  LIST_READING_SESSION_AUDIT: `${BASE_URL}/audit/listReadingSessionAudits`,
  LIST_WEEKLY_REPORT_AUDIT: `${BASE_URL}/audit/listWeeklyReportAudits`,
};

export const MAINTENANCE_PERMIT = {
  GRANT: `${BASE_URL}/maintenancePermit/grant`,
  REVOKE: `${BASE_URL}/maintenancePermit/revoke`,
  CURRENT: `${BASE_URL}/maintenancePermit/current`,
  HISTORY: `${BASE_URL}/maintenancePermit/history`,
};

// Employee Session V2 — new endpoints introduced by the redesign (spec §11)
export const EMPLOYEE_SESSION_V2 = {
  LOAD_SESSION_REPORTS: `${BASE_URL}/report/getSessionReports`,
  LOAD_AUDIT_LOG: `${BASE_URL}/report/getAuditLog`,
  LOAD_OWNER_AUDIT_SETTINGS: `${BASE_URL}/report/getOwnerAuditSettings`,
  SAVE_OWNER_AUDIT_SETTINGS: `${BASE_URL}/report/saveOwnerAuditSettings`,
  LOAD_DUPLICATE_SCORES: `${BASE_URL}/report/getDuplicateScores`,

  EDIT_BONUS: `${BASE_URL}/bonus/editBonusV2`,
  DELETE_BONUS: `${BASE_URL}/bonus/deleteBonusV2`,
  ADD_BONUS: `${BASE_URL}/bonus/addBonusV2`,
  BONUS_DECISION: `${BASE_URL}/bonus/bonusDecision`,

  EDIT_RAFFLE: `${BASE_URL}/raffle/editRaffleV2`,
  DELETE_RAFFLE: `${BASE_URL}/raffle/deleteRaffleV2`,
  ADD_RAFFLE: `${BASE_URL}/raffle/addRaffleV2`,
  RAFFLE_DECISION: `${BASE_URL}/raffle/raffleDecision`,

  EDIT_TICKETOUT: `${BASE_URL}/ticketOut/editTicketOutV2`,
  DELETE_TICKETOUT: `${BASE_URL}/ticketOut/deleteTicketOutV2`,

  EDIT_TRANSACTION: `${BASE_URL}/transaction/editTransactionV2`,
  DELETE_TRANSACTION: `${BASE_URL}/transaction/deleteTransactionV2`,
  ADD_TRANSACTION: `${BASE_URL}/transaction/addTransactionV2`,

  EDIT_CASH_LEFT: `${BASE_URL}/transaction/editCashLeftV2`,
};
